/**
 * Phase 6 — dashboard routes.
 *
 * Permission gating uses operator: "or" with multiple modules where applicable.
 * The CC dashboard is visible to anyone with cost_center.Read OR business_unit_head
 * OR department_head OR eaf — the backend enforces the same set.
 */

import { RouteParam } from "../../../routes";
import { ACTION, MODULE } from "../../../utils/enums";
import { urls } from "../../../utils/urls";
import CCDashboardScreen from "../cc/cc_dashboard";
import FinanceDashboardScreen from "../finance/finance_dashboard";
import BUDashboardScreen from "../bu/bu_dashboard";
import DeptDashboardScreen from "../dept/dept_dashboard";
import MatrixDashboardScreen from "../matrix/matrix_dashboard";
import ProcurementDashboardScreen from "../procurement/procurement_dashboard";

const dashboard_routes: RouteParam[] = [
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.finance_dashboard,
    component: FinanceDashboardScreen,
    // EAF or L3 Finance can view this dashboard (matches backend gate).
    module: MODULE.eaf,
    main_module: MODULE.master_data_panel,
    action: [ACTION.READ],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.matrix_dashboard,
    component: MatrixDashboardScreen,
    // Same gating as Finance — EAF or L3 Finance.
    module: MODULE.eaf,
    main_module: MODULE.master_data_panel,
    action: [ACTION.READ],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.procurement_dashboard,
    component: ProcurementDashboardScreen,
    // EAF / L3 Finance only (matches backend gate).
    module: MODULE.eaf,
    main_module: MODULE.master_data_panel,
    action: [ACTION.READ],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.cc_dashboard + "/:id",
    component: CCDashboardScreen,
    module: MODULE.cost_center,
    main_module: MODULE.master_data_panel,
    action: [ACTION.READ],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.bu_dashboard + "/:id",
    component: BUDashboardScreen,
    // Backend gates on business_unit_head | eaf | finance_approval_L3.
    // ProtectedRoute checks one module; we use business_unit since anyone with
    // BU read can drill in (mirrors how list-pages are gated).
    module: MODULE.business_unit,
    main_module: MODULE.master_data_panel,
    action: [ACTION.READ],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.dept_dashboard + "/:id",
    component: DeptDashboardScreen,
    module: MODULE.department,
    main_module: MODULE.master_data_panel,
    action: [ACTION.READ],
    operator: "or",
  },
];

export default dashboard_routes;
